import React from 'react';
import './Pagination.css';

function Pagination({ page, pages, onPageChange }) {
  if (!pages || pages <= 1) return null;

  const items = [];
  const addPage = (p) => {
    items.push(
      <button
        key={p}
        type="button"
        className={`shop-pagination__btn ${p === page ? 'active' : ''}`}
        onClick={() => onPageChange(p)}
      >
        {p}
      </button>
    );
  };

  addPage(1);
  if (page > 3) items.push(<span key="start-ellipsis" className="shop-pagination__ellipsis">…</span>);
  for (let p = Math.max(2, page - 1); p <= Math.min(pages - 1, page + 1); p += 1) {
    addPage(p);
  }
  if (page < pages - 2) items.push(<span key="end-ellipsis" className="shop-pagination__ellipsis">…</span>);
  if (pages > 1) addPage(pages);

  return (
    <nav className="shop-pagination" aria-label="Pagination">
      <button
        type="button"
        className="shop-pagination__nav"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        Previous
      </button>
      <div className="shop-pagination__pages">{items}</div>
      <button
        type="button"
        className="shop-pagination__nav"
        disabled={page >= pages}
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </button>
    </nav>
  );
}

export default Pagination;
